module.exports = __webpack_public_path__ + "static/media/icon-home.ff02e356.svg";